import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, IsString, ValidateNested, IsOptional } from "class-validator";
import GenericTableResponse from "../../GenericTableResponse";
import { NewContractorAttribute } from "./NewContractorAttribute";

export class ContractorAttribute extends NewContractorAttribute {
  @Expose()
  @IsString()
  id!: string;
  @Expose()
  @IsString()
  description!: string;
  @Expose()
  @IsNumber()
  order!: number;
  @Expose()
  @IsNumber()
  @IsOptional()
  serviceTypeId!: number;
  requestInProgress!: boolean;
  @Expose()
  @IsNumber()
  recordStampId!: number;
}

export class ContractorServiceAttributes {
  @Expose()
  @IsString()
  serviceTypeName!: string;

  @Expose()
  @IsNumber()
  serviceTypeId!: number;

  @Expose()
  @IsString()
  serviceTypeCode!: string;

  @Expose()
  @IsString()
  serviceTypeVAT!: string;

  @Expose()
  @IsArray()
  @Type(() => ContractorAttribute)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  attributes!: Array<ContractorAttribute>;
}

export class ContractorAttributeResponse extends GenericTableResponse<ContractorServiceAttributes> {
  @Expose()
  @IsArray()
  @Type(() => ContractorServiceAttributes)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<ContractorServiceAttributes>;
}
